

const FeatureItem = ({ icon: Icon, title, description }) => (
  <div className="flex items-start gap-4">
    <span className="p-[2px] rounded-xl border-2 border-[#1D6076] text-[#1D6076] text-3xl md:text-4xl shrink-0">
      <Icon />
    </span>
    <div>
      <h3 className="text-base md:text-xl lg:text-2xl font-semibold mb-1 text-[#1E1F21]">{title}</h3>
      <p className="text-[#50555C] text-sm lg:text-lg leading-relaxed">
        {description}
      </p>
    </div>
  </div>
);

const FeatureList = ({ features }) => (
  <div className=" flex flex-col gap-8 md:gap-12 px-1">
    {features.map((feature, idx) => (
      <FeatureItem key={idx} {...feature} />
    ))}
  </div>
);

export default FeatureList;
